import Cookies from 'js-cookie'

const TOKEN_KEY = 'loginToken';


export function setToken(token) {
  // cookie 有效期 7 天
  return Cookies.set(TOKEN_KEY, token, {expires: 7});
}

export function getToken() {
  return Cookies.get(TOKEN_KEY);
}

export function removeToken() {
  return Cookies.remove(TOKEN_KEY);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js